import React, { useState } from 'react';
import moment from 'moment';
import { useMappedState } from 'redux-react-hook';
import { Descriptions, List, Empty, Tabs, Statistic, Card, Row, Col, Modal, Icon, Button, Table, Tag } from 'antd';
import { flexCenterRight } from './../theme';
import CustomAvatar from './../components/customAvatar';
import { s3 } from './../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  getUserStartInit,
  renderUserInvoices,
  showTabTitle,
  showUserTabTitle,
  getInvoices,
  getCompanyExpenditures,
  getCompanyTax,
  getCompanyDividend,
  getSalariesAndExpenditures,
  getUserEndBalance,
  getLastYearAccountLeftTotal,
  getUserEndBalanceTotal
} from './../utils/transaction';
import { format } from 'timeago.js';

const { TabPane } = Tabs;

const { sumBy, orderBy } = require('lodash');

const getFinalAccountBalance = (yearData, user) => {
  const dividend = getCompanyDividend(yearData, user);
  const tax = getCompanyTax(yearData, user);
  const lastYearTotal = getLastYearAccountLeftTotal(yearData);
  const endBalance = getUserEndBalance(yearData, user);
  const endBalanceTotal = getUserEndBalanceTotal(yearData);
  const lastYear = yearData.usersStartBalance[user.id];
  return {
    totalDividend: dividend.total,
    paidDividend: dividend.meDividend,
    totalTax: tax.total,
    paidTax: tax.meTax,
    lastYearTotal,
    lastYear,
    endBalance: parseFloat(endBalance),
    endBalanceTotal,
    totalFinal: parseFloat(lastYearTotal) + parseFloat(endBalanceTotal) - parseFloat(tax.total) - parseFloat(dividend.total),
    final: parseFloat(lastYear) + parseFloat(endBalance) - parseFloat(tax.meTax) - parseFloat(dividend.meDividend),
  }
}

function TransactionPanel({ transactionsData, users }) {
  const me = useMappedState(state => state.me);
  const [yearData, setYearData] = useState(null);
  const [detailsType, setDetailsType] = useState(null);

  const columns = [
    {
      title: 'Year',
      width: '10%',
      key: 'year',
      render: t =>
        <div>{t.year}</div>
    },
    {
      title: '',
      width: '40%',
      key: 'year',
      render: t =>
        <span style={{ color: '#aaa', fontSize: '12px' }}>
          <i>updated {format(new Date(moment(t.updatedAt).format('YYYY-MM-DD HH:mm:ss')))}</i>
        </span>
    },
    {
      title: '',
      width: '50%',
      render: (t) => <div style={flexCenterRight}>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            const found = transactionsData.find((i) => i.year === t.year);
            if (found) {
              setYearData(found);
            }
          }}
        >
          <Icon type="plus" /> Details
        </Button>
      </div>
    }
  ];

  const renderDetailsContent = () => {
    switch (detailsType) {
      case 'Invoices':
        return renderInvoicesContent();
      case 'Company Sales':
        return renderCompanySalesContent();
      case 'Company Expenditures':
        return renderCompanyExpendituresContent();
      case 'Company Tax':
        return renderCompanyTaxContent();
      case 'Dividends':
        return renderDividendsContent();
      case 'Salaries & Expenditures':
        return renderSalariesAndExpendituresContent();
      case 'Account Balance Left (Before Tax)':
        return renderAccountBalanceLeftContent();
      case 'Last Year Bank Account Left (After Tax)':
        return renderLastYearAccountLeftContent();
      case 'Final Account Balance':
        return renderFinalAccountBalanceContent();
      default:
        return null;
    }
  }

  const renderUserFinalAccountBalanceContent = (user) => {
    return (
      <div>
        <Descriptions title="" layout="vertical" bordered>
          <Descriptions.Item label="Total Account Balance">
            <Statistic value={getFinalAccountBalance(yearData, user).final} precision={2} prefix={`£`} />
          </Descriptions.Item>
          <Descriptions.Item span={2}>
            <Row>
              <Col span={6}>
                <p>Last Year Balance(Aft.Tax): <Statistic value={getFinalAccountBalance(yearData, user).lastYear} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={6}>
                <p>This Year Balance(Bef.Tax): <Statistic value={getFinalAccountBalance(yearData, user).endBalance} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={6}>
                <p>Company Tax Paid: <Statistic value={getFinalAccountBalance(yearData, user).paidTax} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={6}>
                <p>Dividend Paid: <Statistic value={getFinalAccountBalance(yearData, user).paidDividend} precision={2} prefix={`£`} /></p>
              </Col>
            </Row>
          </Descriptions.Item>
        </Descriptions>
      </div>
    )
  }

  const renderFinalAccountBalanceContent = () => {
    return (
      <Tabs
        type="card"
        defaultActiveKey={me.id}
      >
        {yearData.users.map((user) => (
          <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
            <div>
              {
                renderUserFinalAccountBalanceContent(user)
              }
            </div>
          </TabPane>
        ))}
      </Tabs>
    )
  }

  const renderUserLastYearAccountLeftDetail = (user) => {
    return (
      <div style={{ marginLeft: '10px' }}>
        <Row>
          <Col span={12}>
            <Statistic title="Last Year Bank Account Left (After Tax)" value={yearData.usersStartBalance[user.id]} precision={2} prefix={`£`} />
          </Col>
        </Row>
      </div>
    )
  }

  const renderLastYearAccountLeftContent = () => {
    return (
      <Tabs
        type="card"
        defaultActiveKey={me.id}
      >
        {yearData.users.map((user) => (
          <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
            <div>
              {
                renderUserLastYearAccountLeftDetail(user)
              }
            </div>
          </TabPane>
        ))}
      </Tabs>
    )
  }

  const renderInvoicesContent = () => {
    if (getInvoices(yearData, users, me).invoices.length > 0) {
      return (
        <Tabs
          type="card"
          defaultActiveKey={me.id}
        >
          {getInvoices(yearData, users, me).invoices.map((pane) => (
            <TabPane tab={showTabTitle(pane, me)} key={pane.userDetails.id}>
              <div>{renderUserInvoices(pane.data)}</div>
            </TabPane>
          ))}
        </Tabs>
      )
    }
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const renderCompanySalesContent = () => {
    const salesData = yearData.transaction.sales.data.map((i) => {
      return {
        ...i,
        ...{ newDate: moment(i.Date) }
      }
    });
    if (salesData.length > 0) {
      return (
        <List
          style={{ maxHeight: '400px', overflow: "auto" }}
          size="small"
          bordered
          footer={<div style={flexCenterRight}>
            <div style={{ marginRight: '8px' }}>
              Total:&nbsp;&nbsp;<Tag>£{yearData.transaction.sales.total.toLocaleString()}</Tag>
            </div>
          </div>}
          dataSource={orderBy(salesData, 'newDate', 'desc')}
          renderItem={item => <List.Item actions={[<span><Tag color="#B0BF1A">£{item.Debit.toLocaleString()}</Tag></span>]}>
            <div>
              <span>{moment(item.Date).format('YYYY-MM-DD')}</span>,&nbsp;
              <span><Tag>{item.Description}</Tag></span>
            </div>
          </List.Item>}
        />
      )
    }
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  }

  const renderCompanyExpendituresContent = () => {
    const expendituresData = yearData.transaction.companyExpenditures.data.map((i) => {
      return {
        ...i,
        ...{ newDate: moment(i.Date) }
      }
    });
    if (expendituresData.length > 0) {
      return (
        <List
          style={{ maxHeight: '400px', overflow: "auto" }}
          size="small"
          bordered
          footer={<div style={flexCenterRight}>
            <div style={{ marginRight: '8px' }}>
              Total:&nbsp;&nbsp;<Tag>£{yearData.transaction.companyExpenditures.total.toLocaleString()}</Tag>
            </div>
          </div>}
          dataSource={orderBy(expendituresData, 'newDate', 'desc')}
          renderItem={item => <List.Item actions={[<span><Tag color="#FB607F">£{item.Credit.toLocaleString()}</Tag></span>]}>
            <div>
              <span>{moment(item.Date).format('YYYY-MM-DD')}</span>,&nbsp;
              <span><Tag>{item.category}</Tag></span>,&nbsp;
              <span>{item.Description}</span>
            </div>
          </List.Item>}
        />
      )
    }
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  }

  const renderUserCompanyTaxPaid = (user) => {
    return (
      <div style={{ marginLeft: '10px' }}>
        <Row>
          <Col span={12}>
            <Statistic title="Tax Paid" value={getCompanyTax(yearData, user).meTax} precision={2} prefix={`£`} />
          </Col>
        </Row>
        <br />
        <div style={{ marginBottom: '5px' }}>{getCompanyTax(yearData, user).info}</div>
      </div>
    )
  }

  const renderCompanyTaxContent = () => {
    return (
      <div>
        <Tabs
          type="card"
          defaultActiveKey={me.id}
        >
          {yearData.users.map((user) => (
            <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
              <div>
                {renderUserCompanyTaxPaid(user)}
              </div>
            </TabPane>
          ))}
        </Tabs>
      </div>
    )
  }

  const renderUserDividendPaid = (user) => {
    return (
      <div style={{ marginLeft: '10px' }}>
        <Row>
          <Col span={12}>
            <Statistic title="Dividend Paid" value={getCompanyDividend(yearData, user).meDividend} precision={2} prefix={`£`} />
          </Col>
        </Row>
        <br />
        <div style={{ marginBottom: '5px' }}>{getCompanyDividend(yearData, user).info}</div>
      </div>
    )
  }

  const renderDividendsContent = () => {
    return (
      <div>
        <Tabs
          type="card"
          defaultActiveKey={me.id}
        >
          {yearData.users.map((user) => (
            <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
              <div>
                {renderUserDividendPaid(user)}
              </div>
            </TabPane>
          ))}
        </Tabs>
      </div>
    )
  }

  const renderUserSalariesAndExpenditures = (user) => {
    const userData = yearData.transaction.userSalaryExpenditures[user.id];
    const salaryData = userData.salary.map((i) => {
      return {
        ...i,
        ...{ newDate: moment(i.Date) }
      }
    });
    const expenditureData = userData.expenditure.map((i) => {
      return {
        ...i,
        ...{ newDate: moment(i.Date) }
      }
    });
    const totalSalary = sumBy(salaryData, 'Credit');
    const totalExpenditure = sumBy(expenditureData, 'Credit');

    return (
      <Tabs animated={false}>
        <TabPane tab="Salaries" key="salaries">
          <div>
            {
              salaryData.length > 0 ? (
                <List
                  style={{ maxHeight: '400px', overflow: "auto" }}
                  size="small"
                  bordered
                  footer={<div style={flexCenterRight}>
                    <div style={{ marginRight: '8px' }}>
                      Total:&nbsp;&nbsp;<Tag>£{totalSalary.toLocaleString()}</Tag>
                    </div>
                  </div>}
                  dataSource={orderBy(salaryData, 'newDate', 'desc')}
                  renderItem={item => <List.Item actions={[<span><Tag color="#B0BF1A">£{item.Credit.toLocaleString()}</Tag></span>]}>
                    <div>
                      <span>{moment(item.Date).format('YYYY-MM-DD')}</span>,&nbsp;
                      <span><Tag>{item.Description}</Tag></span>
                    </div>
                  </List.Item>}
                />
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
          </div>
        </TabPane>
        <TabPane tab="Expenditures" key="expenditures">
          <div>
            {
              expenditureData.length > 0 ? (
                <List
                  style={{ maxHeight: '400px', overflow: "auto" }}
                  size="small"
                  bordered
                  footer={<div style={flexCenterRight}>
                    <div style={{ marginRight: '8px' }}>
                      Total:&nbsp;&nbsp;<Tag>£{totalExpenditure.toLocaleString()}</Tag>
                    </div>
                  </div>}
                  dataSource={orderBy(expenditureData, 'newDate', 'desc')}
                  renderItem={item => <List.Item actions={[<span><Tag color="#B0BF1A">£{item.Credit.toLocaleString()}</Tag></span>]}>
                    <div>
                      <span>{moment(item.Date).format('YYYY-MM-DD')}</span>,&nbsp;
                      <span><Tag>{item.Description}</Tag></span>
                    </div>
                  </List.Item>}
                />
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
          </div>
        </TabPane>
      </Tabs>
    )
  }

  const renderSalariesAndExpendituresContent = () => {
    if (yearData.users.length > 0) {
      return (
        <Tabs
          type="card"
          defaultActiveKey={me.id}
        >
          {yearData.users.map((user) => (
            <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
              <div>
                {renderUserSalariesAndExpenditures(user)}
              </div>
            </TabPane>
          ))}
        </Tabs>
      )
    }
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const renderUserAccountBalanceLeftDetail = (user) => {
    const totalIncome = yearData.usersEndBalance[user.id]['totalEarn'];
    const totalSpending = yearData.usersEndBalance[user.id]['totalPaid'];
    return (
      <div>
        <Descriptions title="" layout="vertical" bordered>
          <Descriptions.Item label="Total Income">
            <Statistic value={totalIncome} precision={2} prefix={`£`} />
          </Descriptions.Item>
          <Descriptions.Item label="" span={2}>
            <Row>
              <Col span={12}>
                <p>Balance Init: <Statistic value={yearData.usersTransactionDetails[user.id]['initBalance']} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={12}>
                <p>Invoices Sale: <Statistic value={yearData.usersTransactionDetails[user.id]['invoicesPaid']} precision={2} prefix={`£`} /></p>
              </Col>
            </Row>
          </Descriptions.Item>
          <Descriptions.Item label="Total Spending">
            <Statistic value={totalSpending} precision={2} prefix={`£`} />
          </Descriptions.Item>
          <Descriptions.Item span={2}>
            <Row>
              <Col span={8}>
                <p>Compnay Expenditures: <Statistic value={yearData.usersTransactionDetails[user.id]['companyExpenditures']} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={8}>
                <p>Individual Salaries: <Statistic value={yearData.usersTransactionDetails[user.id]['userSalaries']} precision={2} prefix={`£`} /></p>
              </Col>
              <Col span={8}>
                <p>Individual Expenditures: <Statistic value={yearData.usersTransactionDetails[user.id]['userExpenditures']} precision={2} prefix={`£`} /></p>
              </Col>
            </Row>
          </Descriptions.Item>
          <Descriptions.Item label="Account Balance Left (Before Tax)">
            <Statistic
              valueStyle={getUserEndBalance(yearData, user) > 0 ? { color: '#8DB600' } : { color: '#cf1322' }}
              value={getUserEndBalance(yearData, user)}
              precision={2}
              prefix={`£`}
            />
          </Descriptions.Item>
        </Descriptions>
      </div>
    )
  }

  const renderAccountBalanceLeftContent = () => {
    return (
      <Tabs
        type="card"
        defaultActiveKey={me.id}
      >
        {yearData.users.map((user) => (
          <TabPane tab={showUserTabTitle(user, me)} key={user.id}>
            <div>
              {
                renderUserAccountBalanceLeftDetail(user)
              }
            </div>
          </TabPane>
        ))}
      </Tabs>
    )
  }

  const renderYearTitle = (yearData) => {
    return <span>
      {`Year ${yearData.year} Details`}&nbsp;&nbsp;
      <span style={{ color: "#ccc", fontSize: '12px' }}>
        <i>Updated {format(new Date(moment(yearData.updatedAt).format('YYYY-MM-DD HH:mm:ss')))}</i>
      </span>
    </span>;
  }

  let totalAccoountLeft;
  if (yearData) {
    totalAccoountLeft = yearData.users.map((i) => {
      return Number(getUserEndBalance(yearData, i))
    });
    totalAccoountLeft = sumBy(totalAccoountLeft).toFixed(2);
  }

  return (
    <div>
      {
        detailsType ? (
          <Modal
            centered={true}
            title={`${detailsType} Details`}
            closable={false}
            visible={detailsType !== null}
            width="85%"
            footer={[
              <Button
                key="close"
                onClick={() => {
                  setDetailsType(null);
                }}
              >
                <Icon type="close" />
                Close
              </Button>
            ]}
          >
            {renderDetailsContent()}
          </Modal>
        ) : null
      }
      {
        yearData ? (
          <Modal
            centered={true}
            title={<Row>
              <Col span={12}>
                <div>{renderYearTitle(yearData)}</div>
              </Col>
              <Col span={12} style={flexCenterRight}>
                <div>
                  <CustomAvatar
                    colourCode={me.firstname.charAt(0).toLowerCase()}
                    char={`${me.firstname.charAt(0).toUpperCase()}${me.lastname.charAt(0).toUpperCase()}`}
                    charSize={13}
                    size={26}
                    src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${me.id}.jpeg`}
                  />
                  &nbsp;&nbsp;
                  {me.firstname} {me.lastname}
                </div>
              </Col>
            </Row>}
            closable={false}
            visible={yearData !== null}
            width="95%"
            footer={[
              <Button
                key="close"
                onClick={() => {
                  setYearData(null);
                }}
              >
                <Icon type="close" />
                Close
              </Button>
            ]}
          >
            <div style={{ maxHeight: '400px', overflow: "auto" }}>
              <Row>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', height: '120px' }}>
                    <Statistic title={`Account Balance Init`} value={getUserStartInit(yearData)} precision={2} prefix={`£`} />
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Invoices" value={getInvoices(yearData, users, me).meSales} precision={2} prefix={`£`} suffix={<span>
                      / £{getInvoices(yearData, users, me).total.toLocaleString()} (Total)
                    </span>} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Invoices');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Company Sales (Total)" value={yearData.transaction.sales.total} precision={2} prefix={`£`} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Company Sales');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', height: '120px' }}>
                    <Statistic title="Company Expenditures" value={getCompanyExpenditures(yearData).meExpenditures} precision={2} prefix={`£`} suffix={<span>
                      / £{getCompanyExpenditures(yearData).total.toLocaleString()} (Total)
                    </span>} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Company Expenditures');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Salaries & Expenditures" value={getSalariesAndExpenditures(yearData, me)} precision={2} prefix={`£`} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Salaries & Expenditures');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', height: '120px' }}>
                    <Statistic
                      valueStyle={getUserEndBalance(yearData, me) > 0 ? { color: '#8DB600' } : { color: '#cf1322' }}
                      title="Account Balance Left (Before Tax)"
                      value={getUserEndBalance(yearData, me)}
                      precision={2}
                      prefix={`£`}
                      suffix={<div>
                        {
                          totalAccoountLeft > 0 ? (
                            <div style={{ color: '#8DB600' }}>/ £{totalAccoountLeft} (Total)</div>
                          ) : (
                            <div style={{ color: '#cf1322' }}>/ £{totalAccoountLeft} (Total)</div>
                          )
                        }
                      </div>}
                    />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Account Balance Left (Before Tax)');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Company Tax" value={getCompanyTax(yearData, me).meTax} precision={2} prefix={`£`} suffix={<span>
                      / £{getCompanyTax(yearData, me).total.toLocaleString()} (Total)
                    </span>}
                    />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Company Tax');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Dividends" value={getCompanyDividend(yearData, me).meDividend} precision={2} prefix={`£`} suffix={<span>
                      / £{getCompanyDividend(yearData, me).total.toLocaleString()} (Total)
                    </span>} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Dividends');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title="Last Year Bank Account Left (After Tax)" value={yearData.usersStartBalance[me.id]} precision={2} prefix={`£`} suffix={<span>
                      / £{(getLastYearAccountLeftTotal(yearData)).toFixed(2)} (Total)
                    </span>} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Last Year Bank Account Left (After Tax)');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={8}>
                  <Card hoverable style={{ marginRight: '5px', marginLeft: '5px', height: '120px' }}>
                    <Statistic title={<b>Final Account Balance</b>} value={getFinalAccountBalance(yearData, me).final} precision={2} prefix={`£`} suffix={<span>
                      / £{(getFinalAccountBalance(yearData, me).totalFinal).toFixed(2)} (Total)
                    </span>} />
                    <Row>
                      <Col span={18}>
                      </Col>
                      <Col span={6}>
                        <div style={flexCenterRight}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setDetailsType('Final Account Balance');
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            Details
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </div>
          </Modal>
        ) : null
      }
      <Table
        columns={columns}
        dataSource={transactionsData}
        rowKey="_id"
      />
    </div>
  );
}

export default TransactionPanel;